module.exports = __webpack_public_path__ + "40d9f050f3553fafce85831887ab9d30.png";